import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';

export class WsCore {
     constructor(public http: HttpClient, public session: SessionService) {}

     _commonOptions(other) {
          let common = {} as any;
          let token = this.session.getToken();
          if (token) {
               common.headers = {
                    Authorization: token,
               };
          } else {
               // console.error('No token provided!');
          }
          return { ...common, ...other };
     }
}
